import Axios from "axios";
var UpperPaymentService = (function () {
    function UpperPaymentService() {
    }
    UpperPaymentService.prototype.getPaymentType = function () {
        return Axios.post("api/payment_type");
    };
    UpperPaymentService.prototype.create = function (params) {
        return Axios.get("supplierclientapi/upper_payment_order/create", { params: params });
    };
    UpperPaymentService.prototype.getPaymentList = function (params) {
        return Axios.get("supplierclientapi/upper_payment_order/list", { params: params });
    };
    UpperPaymentService.prototype.getUpdateInfo = function (params) {
        return Axios.get("supplierclientapi/upper_payment_order/update_info", { params: params });
    };
    UpperPaymentService.prototype.update = function (params) {
        return Axios.get("supplierclientapi/upper_payment_order/update", { params: params });
    };
    UpperPaymentService.prototype.detail = function (params) {
        return Axios.get("supplierclientapi/upper_payment_order/detail", { params: params });
    };
    UpperPaymentService.prototype.audit = function (params) {
        return Axios.post("supplierclientapi/upper_payment_order/audit", params);
    };
    UpperPaymentService.prototype.delete = function (params) {
        return Axios.get("supplierclientapi/upper_payment_order/cancel", { params: params });
    };
    UpperPaymentService.prototype.changeIsTaxTicket = function (params) {
        return Axios.post("supplierclientapi/upper_payment_order/change_is_tax_ticket", params);
    };
    UpperPaymentService.createInstance = function () {
        UpperPaymentService.getInstance();
    };
    UpperPaymentService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return UpperPaymentService;
}());
export default UpperPaymentService;
